import { combineReducers } from 'redux'
import { routerReducer } from '../../routerHistory'
import { reducer as oidcReducer } from 'redux-oidc'

import companyProfileReducer from './companyProfile.reducer'
import lightEntrepreneursReducer from './lightEntrepreneurs.reducer'
import assignmentsReducer from './assignments.reducers'
import registerForm from './register.reducer'
import loginForm from './login.reducer'
import clientReducer from './client.reducer'
import resetPassword from './resetPassword.reducer'
import language from './lang.reducer'
import loaderReducer from './loader.reducer'
import routerLocationsReducer from './routerLocations.reducer'
import companyListsReducer from '../companyDetails.reducer'
import { formReducer } from '../../form'
import paginationReducer from './dropDownPagination.reducer'
import applicationsReducer from './applications.reducer'
import workshiftsReducer from './workshifts.reducer'

import { LOGOUT } from '../../constants/employer'
import contractsReducer from './contracts.reducer'

/**
 * TODO: describe this
 *
 * @author Pragya Gupta
 */

const appReducer = combineReducers({
  loader: loaderReducer,
  oidc: oidcReducer,
  router: routerReducer,
  routerLocations: routerLocationsReducer,
  companyProfile: companyProfileReducer, // huong - EMPLOPYERS LOGIN APPLICATION
  lightEntrepreneurs: lightEntrepreneursReducer,
  assignments: assignmentsReducer,
  applications: applicationsReducer,
  workshifts: workshiftsReducer,
  contracts: contractsReducer,
  register: registerForm,
  login: loginForm,
  client: clientReducer,
  resetPassword: resetPassword,
  language: language,
  companyLists: companyListsReducer,
  form: formReducer,
  pagination: paginationReducer
})

const rootReducer = (state, action) => {
  return appReducer(
    action.type === LOGOUT
      ? {
          ...appReducer({}, {}),
          form: (state && { ...state.form, userSelector: {} }) || {}
        }
      : state,
    action
  )
}

export default rootReducer
